module.exports = __webpack_public_path__ + "img/us.70cd578d.svg";